import type { FaireProductEntity } from "../../entity_types/product";

export const p_8nb46ysynu: FaireProductEntity = {
  token: "p_8nb46ysynu",
  type: "product",
  name: "Cheesy Wishes Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f1f3cca976021c2495ea947758e6d26487806e704e14811b5cd16fe743119f9d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d3a2da93a8467d618cb443fc9d742103a20fce9e5d3f67a49679c2d38464e89.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "Our Cheesy Wishes Birthday Greeting Card from E. Frances Paper is sure to bring a smile to your loved one's face. With a playful message, 'It ain't brie-sy to be this cheesy,' this card embraces humor and warmth, making it perfect for those who appreciate a good pun. As part of our greeting card collection, this card continues our tradition of delivering joy and connection. Based in Newport, RI, E. Frances Paper brings unexpected words and illustrations that spark laughter and nostalgia.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:19.526Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
